const apiPrefix = location?.pathname?.split('/')?.[1];

// TODO: Remove ez prefix check when devops update all ENVIRONMENTS
export const API_PREFIX = apiPrefix && apiPrefix === 'ez' ? `/${apiPrefix}` : '';
